import "../assets/css/loading.css";
const Loading = () => {
  return <div className="loadings"></div>;
};

export default Loading;
